/**
 * @NOTE
 * @InitialValues  - are equivalent to Types When in Used in Type Script
 */

export const daytimetouristInitialValues = {
  phResident: [],
  nonPhResident: [],
};
